import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#ACB8C3"
      d="M73.946 19.213a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M102.555 14.44a1.5 1.5 0 0 1 0 2.12l-9.994 9.995a1.5 1.5 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M90.44 14.44a1.5 1.5 0 0 1 2.12 0l9.995 9.993a1.501 1.501 0 0 1-2.122 2.121l-9.994-9.993a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M43.958 115.164a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M8.566 44a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 1 1-3 0V45.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M0 52.566a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H1.5a1.5 1.5 0 0 1-1.5-1.5M18.633 24.821a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M34 31c.927 0 1.758.582 2.087 1.462l17.767 47.464c.261.697.168 1.48-.249 2.094a2.22 2.22 0 0 1-1.838.98H16.233a2.22 2.22 0 0 1-1.838-.98 2.3 2.3 0 0 1-.25-2.094l17.767-47.464A2.235 2.235 0 0 1 33.999 31m0 8.651L19.472 78.464h29.056zM82 31c.928 0 1.759.582 2.088 1.462l17.766 47.464c.261.697.168 1.48-.249 2.094a2.22 2.22 0 0 1-1.838.98H64.233a2.22 2.22 0 0 1-1.838-.98 2.3 2.3 0 0 1-.25-2.094l17.768-47.464A2.235 2.235 0 0 1 82 31M67.473 78.464h29.056L82 39.651z"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M62.53 33.25A2.246 2.246 0 0 1 64.772 31h16.986A2.246 2.246 0 0 1 84 33.25a2.246 2.246 0 0 1-2.242 2.25H64.772a2.246 2.246 0 0 1-2.242-2.25M32 33.25A2.246 2.246 0 0 1 34.242 31h16.835a2.246 2.246 0 0 1 2.242 2.25 2.246 2.246 0 0 1-2.242 2.25H34.242A2.246 2.246 0 0 1 32 33.25"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M49 34a9 9 0 1 1 18 0 9 9 0 0 1-18 0M54.092 77c1.124 0 2.005.97 1.9 2.085C54.936 90.258 45.492 99 34 99s-20.938-8.742-21.991-19.915a1.91 1.91 0 0 1 1.9-2.085zM61.908 77c-1.124 0-2.005.97-1.9 2.085C61.064 90.258 70.508 99 82 99s20.938-8.742 21.991-19.915A1.91 1.91 0 0 0 102.092 77z"
    />
  </svg>
);
const SvgEnrichedIconCompareGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCompareGreyscale);
export default Memo;
